export default "SELECT\n    syscall\nFROM\n    syzk_all_syscalls;";